import React from 'react';
import { ConnectorsPage } from '../Connectors/ConnectorsPage';

export const RootPage: React.FC = () => {
  return (
    //to fix type instantiation is excessively deep and infinite
    <ConnectorsPage />
  );
};
